import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingComponent } from '../../loading/loading.component';
import { ProgressService } from '../../lib/progress.service';

@Component({
  selector: 'app-booking-form',
  imports: [LoadingComponent],
  templateUrl: './booking-form.component.html',
})
export class BookingFormComponent {
  public readonly route = inject(ActivatedRoute);
  public readonly progressService = inject(ProgressService);
  public router = inject(Router);

  continueBooking(type: string) {
    if(type === "date") {
      this.progressService.resetLodge();
    } else {
      this.progressService.resetDate();
    }

    this.router.navigate([
      'booking',
      this.route.snapshot.paramMap.get('eventSlug'),
      type
    ]);
  }
}
